import type { ButtonHTMLAttributes } from 'react';
import { Icon, type IconName } from './Icon.js';
import { cx } from './cx.js';

export type ButtonVariant = 'primary' | 'secondary' | 'ghost' | 'danger';

/**
 * Bouton du design system. Une seule action `primary` par écran ou modale ;
 * `ghost` pour l'action de retrait à côté ; `danger` toujours avec un libellé.
 * Bouton icône seule : passer `icon` sans enfants ET un `aria-label`.
 */
export function Button({ variant = 'secondary', size = 'md', icon, className, children, type = 'button', ...rest }: {
  variant?: ButtonVariant;
  size?: 'md' | 'sm';
  icon?: IconName;
} & ButtonHTMLAttributes<HTMLButtonElement>) {
  return (
    <button
      type={type}
      {...rest}
      className={cx('pl-btn', `pl-btn-${variant}`, `pl-btn-${size}`, !children && 'pl-btn-icon-only', className)}
    >
      {icon && <Icon name={icon} size={size === 'sm' ? 14 : 16} />}
      {children}
    </button>
  );
}
